import { useSelector } from 'react-redux';
import React from 'react';
import Header from './header';
import Footer from './footer';
import Body from './Body';
import { ILayoutProps } from './types';
import Notification from '../components/notification';
import Captcha from '../components/captcha';
import CardConflictContainer from '../components/cartConflict';
import { isCheckout, isCampaign, isPrepaidRegistraionPage } from '../../utilites/util';
import InformationBar from '../components/informationBar';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { AppState } from '../../app/store/rootReducers';
import MiddlewareEntities from '../../constants/MiddlewareEntities';
import ErrorBoundary from '../components/error-boundary';

export const Layout: React.FC<ILayoutProps> = ({ children }) => {
  const footer = useSelector((state: AppState) => state.pageShell.data.footer);
  const ui = useSelector((state: AppState) => state.ui);
  const isLoadingProductList = ui.entity === MiddlewareEntities.PRODUCTS && ui.loading;
  const renderFooter =
    !isPrepaidRegistraionPage() &&
    !isCheckout() &&
    !isCampaign() &&
    !ui.webview &&
    !isLoadingProductList &&
    Object.keys(footer).length;

  const renderHeader = !isPrepaidRegistraionPage() && !isCheckout() && !isCampaign();

  return (
    <div>
      {isCheckout() && <InformationBar />}
      {renderHeader && <Header />}
      <Body>
        <ErrorBoundary>
          <Notification />
          <Captcha />
          <CardConflictContainer />
          {children}
        </ErrorBoundary>
      </Body>
      {renderFooter && <Footer />}
    </div>
  );
};

export default withRouter(Layout as any) as any as React.FC<Partial<ILayoutProps & RouteComponentProps>>;
